var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.115,
    height: 22.071,
    viewBox: "0 0 21.115 22.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(288.329 -407.185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M-278.556,416.048c2.03,0,3.677-2.505,3.677-4.768a3.9,3.9,0,0,0-3.677-4.1,3.9,3.9,0,0,0-3.677,4.1C-282.233,413.543-280.587,416.048-278.556,416.048Z",
    transform: "translate(-1.5)",
    fill: "#280071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M-272.622,421.415a7.788,7.788,0,0,0-4.786-2.25l-1.53,4.353-.847-2.254,1.343-1.971a5.9,5.9,0,0,1-1.613.78,6.344,6.344,0,0,1-1.662-.78l1.346,1.974-.847,2.254-1.77-4.355c-2.075.078-5.341,1.9-5.341,3.993v4.5H-278c-.012-.157-.023-.314-.023-.473A5.8,5.8,0,0,1-272.622,421.415Z",
    transform: "translate(0 -2.948)",
    fill: "#280071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M-268.574,423.185c-.121,0-.241.009-.36.017l-4.636,5.384a5,5,0,0,0,4.973,4.608,5,5,0,0,0,5.016-4.993A5,5,0,0,0-268.574,423.185Zm.378,8.545a.765.765,0,0,1-.17.247.759.759,0,0,1-.254.164.823.823,0,0,1-.314.06.819.819,0,0,1-.317-.06.756.756,0,0,1-.252-.164.753.753,0,0,1-.17-.247.772.772,0,0,1-.061-.309.778.778,0,0,1,.061-.306.758.758,0,0,1,.17-.25.815.815,0,0,1,.252-.167.82.82,0,0,1,.317-.061.824.824,0,0,1,.314.061.817.817,0,0,1,.254.167.77.77,0,0,1,.17.25.778.778,0,0,1,.061.306A.772.772,0,0,1-268.2,431.73Zm1.318-4.442a1.807,1.807,0,0,1-.265.473,2.005,2.005,0,0,1-.35.348c-.128.1-.249.19-.363.274a2.829,2.829,0,0,0-.3.253.527.527,0,0,0-.154.277l-.123.7h-.927l-.093-.794a.653.653,0,0,1,.059-.409,1.2,1.2,0,0,1,.25-.319,3.205,3.205,0,0,1,.35-.279,3.426,3.426,0,0,0,.363-.29,1.511,1.511,0,0,0,.284-.348.879.879,0,0,0,.115-.458.64.64,0,0,0-.223-.514.875.875,0,0,0-.59-.191,1.479,1.479,0,0,0-.453.059,1.78,1.78,0,0,0-.316.13c-.089.047-.164.09-.226.129a.327.327,0,0,1-.176.06.3.3,0,0,1-.279-.161l-.357-.559a3.378,3.378,0,0,1,.379-.283,2.652,2.652,0,0,1,.441-.231,2.813,2.813,0,0,1,.515-.155,2.97,2.97,0,0,1,.6-.056,2.486,2.486,0,0,1,.8.12,1.774,1.774,0,0,1,.612.343,1.532,1.532,0,0,1,.4.536,1.711,1.711,0,0,1,.139.7A1.786,1.786,0,0,1-266.878,427.288Z",
    transform: "translate(-3.632 -3.938)",
    fill: "#280071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M-273.6,428.183c0,.138.009.274.02.409l4.636-5.384A5,5,0,0,0-273.6,428.183Z",
    transform: "translate(-3.626 -3.943)",
    fill: "#280071"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIcon2);
export default __webpack_public_path__ + "static/media/header-icon-2.434f1ef48b38ed753f076f72c1cfdd6e.svg";
export { ForwardRef as ReactComponent };